/**
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

/** en-dash — must match translated copy used in document titles */
export const pageTitleSeparator = '–'

/** Fallback values used when a translation key is missing from the catalogue. */
export const META_TITLE_FALLBACKS: Record<string, string> = {
  'pidp.generic.meta.title.myProfile': 'Profile Settings',
}

/**
 * Translation keys for `MetaFieldsService` (page headline + brand suffixes).
 * Brand keys must exist in the remote i18n JSON for every locale.
 */
export const PERSONAL_DATA_META_TITLE_KEYS: string[] = ['pidp.personalData.headline', 'pidp.generic.meta.title.myProfile']

export const PAYMENT_META_TITLE_KEYS: string[] = ['PROFILE-TAB-PAYMENT', 'pidp.generic.meta.title.myProfile']

export const SECONDARY_USER_META_TITLE_KEYS: string[] = ['pidp.secondaryUser.headline', 'pidp.generic.meta.title.myProfile']
